<template>
  <div>

<!--    Please enter the ID value of the task to query：-->
      <div v-show="part1" style="text-align: center;height: 600px">
        <strong>Please enter the Task ID to query：</strong>
        <br>
        <br>
        <el-input v-model="InputUid" style="width: 300px" placeholder="Task ID"></el-input>
        <br>
        <br>
        <el-button type="success" @click="fun1()">OK</el-button>
      </div>

<!--    结果的详细页面-->
    <div class="container" v-show="part2">
      <el-breadcrumb separator-class="el-icon-arrow-right"
                     style="font-size: 20px; padding: 20px 10px 20px; background-color: #e6e5e5;">
        <el-breadcrumb-item>Result</el-breadcrumb-item>
      </el-breadcrumb>
      <h3>1. Overview</h3>

      <!--        <ul>-->
      <!--            <li v-for="(o1,o2) in overview">{{o2}}-{{o1}}</li>-->
      <!--        </ul>-->

      <div class="content">
        <el-descriptions :column="2"  border width="190" >
          <el-descriptions-item  v-for="(value,key) in overview">
            <template slot="label">
              {{key}}
            </template>
            <div style="white-space: pre;">{{value}}</div>
          </el-descriptions-item>
        </el-descriptions>

        <br>

        <el-row :gutter="5">
          <el-col :span="8">
            <div id="app1" style="height: 350px;" class="content"></div>
          </el-col>
          <el-col :span="8">
            <div id="app2" style="height: 350px;" class="content"></div>
          </el-col>
          <el-col :span="8">
            <div id="app3" style="height: 350px;" class="content"></div>
          </el-col>
        </el-row>
      </div>

      <div style="margin-top: 10px;margin-bottom: 10px">
        <h3 style="display: inline">2. Results </h3>
        <el-button size="medium" type="primary" plain @click="download()">download as csv</el-button>
<!--        <button @click="f2()">anniu</button>-->
      </div>

      <div class="content">
        <el-table
                :data="entries.slice((currentPage - 1) * pageSize, currentPage * pageSize)"
                stripe
                style="width: 100%">
          <el-table-column
                  prop="index"
                  label="Index"
                  width="100"
                  align="center">
          </el-table-column>

          <el-table-column
                  prop="fig_path"
                  label="2D Structure"
                  align="center">

            <template slot-scope="scope">
              <img :data-smiles="scope.row.SMILES"
                   data-smiles-options="{ 'width': 100, 'height': 100 }" />
<!--              要监听result 和currentPage，当发生变化的时候，调用SmiDrawer.apply()方法-->

<!--              <img :id="'mol_'+scope.row.SMILES" data-smiles-options="{ 'width': 10, 'height': 10 }" />-->
<!--              <canvas :id="'mol_'+scope.row.SMILES" widith="50" height="50"></canvas>-->
<!--              <el-image :src="'https://www.csuligroup.com/DrugGen/getimgdownloadurl'+scope.row.fig_path"></el-image>-->
            </template>

          </el-table-column>
          <el-table-column
                  label="information"
                  width="600"
                  align="center">
            <template slot-scope="scope">
              <el-descriptions :column="1" :size="size" border width="190">
                <el-descriptions-item  label-class-name="my-label">
                  <template slot="label" >
                    SMILES
                  </template>
                  {{scope.row.SMILES}}
                </el-descriptions-item>

                <el-descriptions-item label-class-name="my-label">
                  <template slot="label">
                    Formula
                  </template>
                  {{scope.row.Formula}}
                </el-descriptions-item>

                <el-descriptions-item label-class-name="my-label">
                  <template slot="label" >
                    InChI Key
                  </template>
                  {{scope.row.inchikey}}
                </el-descriptions-item>
                <el-descriptions-item label-class-name="my-label" >
                  <template slot="label" >
                    MolWt
                  </template>
                  {{scope.row.MolWt}}
                </el-descriptions-item>
              </el-descriptions>
            </template>
          </el-table-column>

          <el-table-column
                  style="margin-left: 200px;"
                  prop="detail"
                  label="Detail"
                  align="center">
            <template slot="header" slot-scope="scope">
              detail
            </template>
            <template slot-scope="scope" >
              <el-button
                      size="medium"
                      @click="showDetails(scope.$index, scope.row)">View
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <el-pagination
                style="margin-top: 5px"
                :current-page.sync="currentPage"
                :page-size="pageSize"
                layout="total, prev, pager, next"
                :total="total">
        </el-pagination>
      </div>

    </div>

  </div>

</template>

<script>

  export default {
    name: "Result",
    data() {
      return {
        InputUid:'',
        t400:false,
        t401:false,
        t402:false,
        t403:false,
        userInfo:false,
        part1:false,
        part2:true,
        pageSize: 20,
        currentPage: 1,
        overview: [
        ],
        result: {},
        sa_image:{},
        qed_image:{},
        molwt_image:{},
        xti:'',
        yti:'',
      }

    },
    created() {

      this.InputUid=this.$route.query.sid
      console.log(this.InputUid)
      if(this.InputUid==undefined)
      {
        console.log("this.InputUid==undefined")
        this.part1=true
        this.part2=false
      }

      // if(this.InputUid!=undefined)
      {
        // this.part1=false
        // this.part2=false

        axios.get("/getinfo",{params:{uuid:this.InputUid}}).then(res => {
          this.overview=res.data
        })
        //获取网址中包含的uuid值
        var ip1="http://120.24.94.89:8090/optimization/"
        var ip2="https://www.csuligroup.com/PGMG/optimization/"
        var that=this;
        axios.get(ip2 + this.InputUid).then(res => {
          console.log(res.data)
          console.log("准备画图")
          {
            that.result = res.data.gen_result;
            that.sa_image =res.data.SA;
            that.qed_image =res.data.QED;
            that.molwt_image=res.data.MolWt;
            var myChart1 = this.$echarts.init(document.getElementById('app1'));
            var option1 = {
              color:['#b83b5e'],
              title: {
                text: 'SA',
                left: 'center',//距离容器左边的距离，可取‘left’，‘right’，‘center’
                top:'25px',
              },
              xAxis: {
                type: 'category',
                data: that.sa_image.xti,
                name: that.sa_image.xlabel,
                boundaryGap: true,
              },
              yAxis: {
                type: 'value',
                name: that.sa_image.ylabel
              },
              series: [
                {
                  data: that.sa_image.yti,
                  type: 'bar',
                  // color:red,
                }
              ],
              tooltip: {},
              grid:{show:true, containLabel: true, bottom: '3%',right:"12%",},
            };
            myChart1.setOption(option1);

            var myChart2 = this.$echarts.init(document.getElementById('app2'));
            var option2 = {
              color:['#f08a5d'],
              title: {
                text: 'QED',
                left: 'center',//距离容器左边的距离，可取‘left’，‘right’，‘center’
                top:'25px',
              },
              xAxis: {
                type: 'category',
                data: that.qed_image.xti,
                name: that.qed_image.xlabel,
                boundaryGap: true,
              },
              yAxis: {
                type: 'value',
                name: that.qed_image.ylabel
              },
              series: [
                {
                  data: that.qed_image.yti,
                  type: 'bar',
                  // color:red,
                }
              ],
              tooltip: {},
              grid:{show:true, containLabel: true, bottom: '3%',right:"12%",},
            };
            myChart2.setOption(option2);

            var myChart3 = this.$echarts.init(document.getElementById('app3'));
            var option3 = {
              color:['#f9ed69'],
              title: {
                text: 'MolWt',
                left: 'center',//距离容器左边的距离，可取‘left’，‘right’，‘center’
                top:'25px',
              },
              xAxis: {
                type: 'category',
                data: that.molwt_image.xti,
                name: that.molwt_image.xlabel,
                boundaryGap: true,
              },
              yAxis: {
                type: 'value',
                name: that.molwt_image.ylabel
              },
              series: [
                {
                  data: that.molwt_image.yti,
                  type: 'bar',
                  // color:red,
                }
              ],
              tooltip: {},
              grid:{show:true, containLabel: true, bottom: '3%',right:"23%",},
            };
            myChart3.setOption(option3);
            // that.ff()
          }
        }).catch(err => {
          console.log(err);
        })
      }
    },
    mounted() {
      this.f2()
      console.log(this.result)
    },
    computed: {
      entries() {
        return Object.values(this.result);
      },
      total() {
        return this.entries.length;
      },

    },
    methods: {
      f2(){
        SmiDrawer.apply();
      },
      ff()
      {
        console.log(this.result)
        let res =Object.entries(this.result)

        let moleculeOptions = {};
        let reactionOptions = {};
        let sd = new SmiDrawer(moleculeOptions, reactionOptions);
        for (let i = 0; i <res.length ; i++) {
          let tt=res[i][1].SMILES
          console.log(tt)
          sd.draw(tt, "mol_"+res[i][1].SMILES)
          // SmilesDrawer.parse(tt, function(tree) {
          //   smilesDrawer.draw(tree, "mol_"+res[i][1].SMILES, "light", false);
          //
          // });
        }
      },
      fun1()
      {
        this.$router.push({
          path: '/TemResult',
          query: {
            sid: this.InputUid
          }
        })



        this.part1=false;
        this.part2=true;
        axios.get("/getinfo",{params:{uuid:this.InputUid}}).then(res => {
          this.overview=res.data
          console.log(res.data)
          console.log(this.overview)
        })

        //获取网址中包含的uuid值
        var ip1="http://120.24.94.89:8090/optimization/"
        var ip2="https://www.csuligroup.com/PGMG/optimization/"
        var that=this;
        axios.get(ip2 + this.InputUid).then(res => {
          console.log(res.data)
          // if(res.data.code==200)
          {
            that.result = res.data.gen_result;
            that.sa_image =res.data.SA;
            that.qed_image =res.data.QED;
            that.molwt_image=res.data.MolWt;
            var myChart1 = this.$echarts.init(document.getElementById('app1'));
            var option1 = {
              color:['#b83b5e'],
              title: {
                text: 'SA',
                left: 'center',//距离容器左边的距离，可取‘left’，‘right’，‘center’
                top:'25px',
              },
              xAxis: {
                type: 'category',
                data: that.sa_image.xti,
                name: that.sa_image.xlabel,
                boundaryGap: true,
              },
              yAxis: {
                type: 'value',
                name: that.sa_image.ylabel
              },
              series: [
                {
                  data: that.sa_image.yti,
                  type: 'bar',
                  // color:red,
                }
              ],
              tooltip: {},
              grid:{show:true, containLabel: true, bottom: '3%',right:"12%",},
            };
            myChart1.setOption(option1);

            var myChart2 = this.$echarts.init(document.getElementById('app2'));
            var option2 = {
              color:['#f08a5d'],
              title: {
                text: 'QED',
                left: 'center',//距离容器左边的距离，可取‘left’，‘right’，‘center’
                top:'25px',
              },
              xAxis: {
                type: 'category',
                data: that.qed_image.xti,
                name: that.qed_image.xlabel,
                boundaryGap: true,
              },
              yAxis: {
                type: 'value',
                name: that.qed_image.ylabel
              },
              series: [
                {
                  data: that.qed_image.yti,
                  type: 'bar',
                  // color:red,
                }
              ],
              tooltip: {},
              grid:{show:true, containLabel: true, bottom: '3%',right:"12%",},
            };
            myChart2.setOption(option2);

            var myChart3 = this.$echarts.init(document.getElementById('app3'));
            var option3 = {
              color:['#f9ed69'],
              title: {
                text: 'MolWt',
                left: 'center',//距离容器左边的距离，可取‘left’，‘right’，‘center’
                top:'25px',
              },
              xAxis: {
                type: 'category',
                data: that.molwt_image.xti,
                name: that.molwt_image.xlabel,
                boundaryGap: true,
              },
              yAxis: {
                type: 'value',
                name: that.molwt_image.ylabel
              },
              series: [
                {
                  data: that.molwt_image.yti,
                  type: 'bar',
                  // color:red,
                }
              ],
              tooltip: {},
              grid:{show:true, containLabel: true, bottom: '3%',right:"23%",},
            };
            myChart3.setOption(option3);
          }
          // else if(res.data.code==404)
          // {
          //   this.$alert("The data operation failed, and the result cannot be obtained. Please check the data and upload it again.")
          // }

        }).catch(err => {
          console.log(err);

          axios.get("/search/"+sid).then(res=>{
            console.log(res.data)
            if(res.data.code==401)//数据运行中
            {
              this.t401=true
            }
            else if(res.data.code==402)//uid不存在
            {
              this.t402=true
            }
            else if(res.data.code==403)//数据排队中
            {
              this.t403=true
            }
          })

          // this.$alert("The program is running and the result is not available temporarily. Please wait patiently.")
        })
        this.getImage()
      },
      //下载csv文件
      download() {
        console.log(this.InputUid)

        var ip1="http://120.24.94.89:8090/optimization/"
        var ip2="https://www.csuligroup.com/PGMG/optimization/"
        // window.open('http://localhost:8080/000001/000001.csv')
        window.open(ip2 + this.InputUid + "/csv")
      },
      showDetails(index, row) {
        console.log(index, row);
        this.$router.push({name: 'Detail', params: this.result['mol_' + index]});
      }
    },
    watch: {
      result(val, value) {
        console.log(val)
        console.log(value)
        this.$nextTick(() => {
          // 渲染table业务
          // this.$refs.industryRef.toggleRowSelection(row)
          this.f2()
        })
      },
      currentPage(val, value)
      {
        this.$nextTick(() => {
          // 渲染table业务
          // this.$refs.industryRef.toggleRowSelection(row)
          this.f2()
        })
      }
    }
  }
</script>
<style>
  .my-label
  {
    width: 90px;
  }
</style>

<style scoped>

  .container {
    max-width: 1160px;
    margin: 0 auto;
  }

  * {
    /*text-align: left;*/
  }
  .content{
    box-shadow: rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px;
    background-color: RGB(255,255,255);
    border-radius: 10px;
    padding: 10px;
  }
</style>
